import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicLaplacePeriodicFunctions = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="LAPLACE TRANSFORM OF PERIODIC FUNCTIONS"
      videos={[
        "https://www.youtube.com/embed/MM3vi7mQ60U?list=PLU6SqdYcYsfIWugLkTq1nMoU3rDDx7xpG",
        "https://www.youtube.com/embed/RhhE_Xr-n3E?list=PLhSp9OSVmeyIYLVvSJ8m6KvVwJs7M9QBm",
      ]}
      takeaways={[
        { text: "Practice as many problems as you can" },
      ]}
      questions={[]} // Empty questions as there were none provided
      exampleVideos={[]} // Empty example videos
    />
);
}

export default ModuleSubtopicLaplacePeriodicFunctions;